import React from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Features from './components/Features'
import ScienceBack from './components/ScienceBack'
import Pricing from './components/Pricing'
import GuranteeLicence from './components/GuranteeLicence'
import FAQs from './components/FAQs'
import ScientificReferences from './components/ScientificReference'
import Footer from './components/Footer'


const LungLanding = () => {
  return (
    <div className="min-h-screen bg-navy-900">
      <Header />
      <Hero />
      <Features />
      <ScienceBack />
      <Pricing />
      <GuranteeLicence />
      <FAQs />
      <Pricing />
      <ScientificReferences />
    <Footer/>
    </div>
  )
}

export default LungLanding
